import { Component, OnInit } from '@angular/core';
import { ContactConfig} from './contact';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  public company = ContactConfig;

  constructor() { }

  ngOnInit = () => {
  }

}
